var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: ["feature-roulette", `direction-${_vm.direction}`],
      on: {
        mouseenter: function ($event) {
          _setup.hasMouseCursor = true
        },
        mouseleave: function ($event) {
          _setup.hasMouseCursor = false
        },
      },
    },
    [
      _c(
        "TransitionGroup",
        { staticClass: "roulette-wheel", attrs: { tag: "div" } },
        _vm._l(_setup.displayedItems, function (item, index) {
          return _c(
            "div",
            {
              key: item.id,
              class: [
                "roulette-item",
                {
                  "is-top": index === 0,
                  "is-focus": index === 1,
                  "is-bottom": index === 2,
                },
              ],
              on: {
                click: function ($event) {
                  return _setup.setToFocus(index)
                },
              },
            },
            [
              _c("div", [
                typeof item.image === "object"
                  ? _c(
                      "div",
                      { staticClass: "item-icon" },
                      [_c("Icon", { attrs: { icon: item.image } })],
                      1
                    )
                  : _c("div", {
                      staticClass: "item-image",
                      style: { backgroundImage: `url(${item.image})` },
                    }),
                _vm._v(" "),
                _c("div", { staticClass: "item-title" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }